import { useEffect, useState } from 'react';
import {
  criteriasList,
  getClients,
  getCountries,
  getPostalStructures,
  getProviders,
  getServiceCodes,
  getServiceTypes,
} from '../../services/rulesService';
import { CriteriaList } from '../../interfaces/rule';
import { isGeolocation } from '../../utils/Rules/CriteriaValidator';

export const useCriteria = () => {
  const [criterias, setCriterias] = useState<CriteriaList[]>([]);
  const [fetchApiList, setFetchApiList] = useState<string[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const criterias = await criteriasList();
      setCriterias(criterias.data);
    };
    fetchData();
  }, []);

  const fetchCountries = async () => {
    try {
      const countries = await getCountries();
      return countries.data.map((c: { name: string, code: string }) => ({ label: c.name, value: c.code }));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchServiceCode = async (criteriaKey: string) => {

    let dataPromise;
    switch (criteriaKey) {
      case 'service_code':
        dataPromise = getServiceCodes();
        break;
      case 'service_types':
        dataPromise = getServiceTypes();
        break;
      case 'clients':
        dataPromise = getClients();
        break;
      case 'distribution_provider':
        dataPromise = getProviders();
        break;
      default:
        dataPromise = null;
    }

    const data = await dataPromise;

    if (data && data.data) {
      return data.data
        .filter(
          (obj: { name: string; code: string }) =>
            obj.name !== null,
        )
        .map((obj: { name: string; code: string }) => ({
          label: `${obj.name} - ${obj.code}`,
          value: obj.code,
        }));
    }
  };

  const loadCountriesAndCities = () => {
    if (!fetchApiList.includes('countries')) {
      fetchCountries().then(response => {
        setCriterias(prev => prev.map(c => {
          if (isGeolocation(c.key)) {
            return { ...c, countries: response };
          }
          return c;
        }));
        setFetchApiList([...fetchApiList, 'countries']);
      });
    }
  };

  const loadCities = (criteriaKey: string, countryCode: string, level: number) => {
    if (!fetchApiList.includes(criteriaKey)) {

      getPostalStructures(countryCode, level).then((response) => {
        setCriterias(prev => prev.map(c => {
          if (criteriaKey == c.key) {
            return {
              ...c,
              cities: response.data.map((c: { name: string }) => ({ label: c.name, value: c.name })),
            };
          }
          return c;
        }));
        setFetchApiList([...fetchApiList, criteriaKey]);
      });
    }
  };

  const loadServiceCode = (criteriaKey: string) => {
    if (!fetchApiList.includes(criteriaKey)) {
      fetchServiceCode(criteriaKey).then(response => {
        setCriterias(prev => prev.map(c => {
          if (criteriaKey === c.key) {
            return { ...c, serviceCode: response };
          }
          return c;
        }));
        setFetchApiList([...fetchApiList, criteriaKey]);
      });
    }
  };


  return {
    criterias,
    loadCountriesAndCities,
    loadServiceCode,
    fetchServiceCode,
    loadCities,
  };
};
